import { render, staticRenderFns } from "./NewLead.vue?vue&type=template&id=4b7bfac4&"
import script from "./NewLead.vue?vue&type=script&lang=js&"
export * from "./NewLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports